import React from 'react';
import { useTranslation } from 'react-i18next';

import { NewVersionToastGlobalStyles, NewVersionToastStyles } from './styles';

const NewVersionToast = () => {
  const { t: translate } = useTranslation();

  return (
    <NewVersionToastStyles>
      <NewVersionToastGlobalStyles />
      <p className="new-version-title">{translate('New version available')}</p>
      <p className="new-version-text">{translate('Reload the page to use the latest version.')}</p>
      <button
        type="button"
        className="btn btn-sm btn-primary"
        onClick={() => window.location.reload()}
      >
        <i className="bx bx-revision" />
        {translate('Reload')}
      </button>
    </NewVersionToastStyles>
  );
};

NewVersionToast.displayName = 'New Version Toast Component';

export default NewVersionToast;
